export default {"src":"/login-app/[GIT_HASH]/_next/static/media/catalog_book.d93d83a1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};